<template>
  <div class="student-edit m-2 p-2">
    <h2 class="text-center student-title">{{ $t('editProfileStudent.editInformation') }}</h2>
    <!-- <i class="fa fa-pencil edit-icon" aria-hidden="true" @click="disabled = !disabled"></i> -->

    <el-form ref="form" :model="form" :rules="rules">
      <div class="row">
        <el-form-item class="col-12 col-sm-6" prop="firstname" :label="$t('singup.name')">
          <el-input
            id="firstname"
            v-model.trim="form.firstname"
            name="name"
            type="text"
            :popper-class="'capitalize'"
            size="small"
            :placeholder="$t('editProfileTutor.first')"
            @focus="$event.target.select()"
          >
          </el-input>
        </el-form-item>
        <el-form-item class="col-12 col-sm-6" prop="lastname" :label="$t('editProfileTutor.last')">
          <el-input
            id="lastname"
            v-model.trim="form.lastname"
            name="lastname"
            type="text"
            :popper-class="'capitalize'"
            size="small"
            :placeholder="$t('editProfileTutor.last')"
            @focus="$event.target.select()"
          >
          </el-input>
        </el-form-item>
        <el-form-item class="col-12 col-sm-6" :label="$t('singup.grade')">
          <el-select
            id="selectGrade"
            v-model="form.gradeId"
            class="w-100"
            :popper-class="'capitalize'"
            size="small"
            @focus="$event.target.select()"
          >
            <el-option v-for="grade in grades" :key="grade.id" :value="grade.id" :label="grade.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="col-12 col-sm-6" prop="username" :label="$t('singup.username')">
          <el-input
            id="username"
            v-model.trim="form.username"
            name="username"
            type="text"
            :popper-class="'capitalize'"
            size="small"
            :placeholder="$t('singup.usernameEx')"
          >
          </el-input>
        </el-form-item>

        <el-form-item class="col-12 col-sm-6" prop="newPassword" :label="$t('editProfileStudent.newPassword')">
          <el-input
            ref="password"
            v-model="form.newPassword"
            type="password"
            name="password"
            :popper-class="'capitalize'"
            size="small"
            show-password
          >
          </el-input>
        </el-form-item>
        <el-form-item class="col-12 col-sm-6" prop="verifyPassword" :label="$t('singup.verifyYourPassword')">
          <el-input
            ref="verifyPassword"
            v-model="form.verifyPassword"
            type="password"
            name="verifyPassword"
            :popper-class="'capitalize'"
            size="small"
            show-password
          >
          </el-input>
        </el-form-item>
      </div>

      <div class="row center-block text-center">
        <el-form-item>
          <el-button type="button" class="btn bg-red text-white" @click="handleCancel">Cancel</el-button>
          <el-button type="submit" class="btn btn-primary" @click="update">submit</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
import swal from 'sweetalert';
//import _ from 'lodash';
export default {
  name: 'StudentEdit',
  props: {
    studentId: {
      type: Number,
      required: true,
    },
    disabledFields: {
      type: Boolean,
      default: true,
    },
    gradeId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value !== '' && this.form.verifyPassword !== '') {
        console.log('verificando passwword');
        this.$refs.form.validateField('verifyPassword');
      }
      callback();
    };
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };
    return {
      showSetPassword: false,
      showPassword: false,
      showVerifyPassword: false,
      //student: null,
      grades: [],
      disabled: this.disabledFields,
      student: {},
      // newPassword: '',
      // verifyPassword: '',
      gradeIDSelected: 0,
      form: {
        firstname: '',
        lastname: '',
        username: '',
        gradeId: null,
        newPassword: '',
        verifyPassword: '',
      },
      rules: {
        firstname: [{ required: true, message: 'Name can not be empty', trigger: 'blur' }],
        lastname: [{ required: true, message: 'Last name can not be empty', trigger: 'blur' }],
        username: [{ required: true, message: 'Username can not be empty', trigger: 'blur' }],
        newPassword: [{ validator: validatePass, trigger: 'blur' }],
        verifyPassword: [{ validator: validatePass2, trigger: 'blur' }],
      },
    };
  },
  created() {
    this.fetchGrades();
    this.getStudent();
  },
  methods: {
    handleCancel() {
      this.$emit('cancel');
    },
    // /** Muestra la opción de setear una nueva contraseña al estudiante */
    fetchGrades() {
      this.$store.commit('app/START_PROCESSING');
      this.$httpMain
        .get(`get_id_name_path_all_grade`)
        .then(res => {
          this.grades = res.data;
          console.log(res.data);
        })
        .finally(() => {
          this.$store.commit('app/STOP_PROCESSING');
        });
    },
    getStudent() {
      this.$httpMain
        .post(`get-student`, {
          student_id: this.studentId,
        })
        .then(res => {
          this.form.lastname = res.data.lastname;
          this.form.username = res.data.username;
          this.form.firstname = res.data.firstname;
          this.form.gradeId = res.data.grade_id;
          this.student = res.data;
        });
    },
    // // Envía el usuario modificado al servidor
    update() {
      this.$refs['form'].validate(valid => {
        //console.log('validacion ' + valid);
        if (valid) {
          var user = {};
          user.id = this.student.id;
          user.firstname = this.form.firstname;
          user.lastname = this.form.lastname;
          user.grade_id = this.form.gradeId;
          //user.name_of_the_school = this.student.name_of_the_school;
          user.username = this.form.username;
          // user.access_all_content = this.accessAllContent
          if (this.form.newPassword === this.form.verifyPassword) {
            user.new_password = this.form.newPassword;
          }

          user.rol_id = 1;
          user.email = 'NA';
          this.$httpMain.post(`edit-user`, user).then(res => {
            if (res.data) {
              swal({
                title: this.$t('messages.succes'),
                // text: this.$t('messages.yourFile'),
                icon: 'success',
              });
              this.$emit('student', user);
            }
          });
        }
        //if (!valid) console.log('no valido');
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/* --------------------------------- */
/* 2. Custom Utility Classes
 ----------------------------------- */
.student-edit {
  position: relative;
  //left: 300px;
  max-width: 700px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.5);
  padding: 2em 3em;
  border-radius: 0.5em;
  font-family: 'comfortaaregular';
}

.student-title {
  font-family: 'comfortaabold';
  margin-bottom: 2rem;
}

.edit-icon {
  position: absolute;
  right: 1em;
  top: 1em;
  padding: 0.5em;
  background-color: green;
  border-radius: 5px;
  color: #fff;
  transition: border-radius 0.3s;
}
.edit-icon:hover {
  border-radius: 50%;
}

.content {
  position: relative;
  background-color: #fff;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.5);
  max-width: 650px;
  border-radius: 10px;
  padding: 1.8rem 1.2rem;
  font-family: 'comfortaaregular';
  .edit-profile {
    position: absolute;
    top: 30px;
    right: 20px;
    width: 30px;
    height: 30px;
    padding: 4px 7px;
    margin: 0;
    color: #fff;
    font-size: 20px;
    background-color: green;
    border-radius: 5px;
    cursor: pointer;
  }
  .btn-cancel {
    position: absolute;
    top: 30px;
    right: 20px;
    width: 30px;
    height: 30px;
    padding: 4px 7px;
    margin: 0;
    color: #fff;
    font-size: 20px;
    background-color: red;
    border-radius: 5px;
    cursor: pointer;
  }
}

.password-info {
  color: #199df5;
  margin-top: 0.5rem;
}
.assign-password {
  cursor: pointer;
}
.info-security {
  margin-bottom: 5px;
  color: #d50000;
  font-size: 14px;
}
.margin-top-2 {
  margin-top: 2rem;
}
.invalid-field {
  color: #d50000;
  font-size: 0.8rem;
}
/* --------------------------------- */
/* 3. Custom Styles
----------------------------------- */
/*customizing boostrap*/
.btn-danger {
  width: 120px;
}
.btn-primary {
  background-color: #199df5;
  color: white;
  border-color: #199df5;
  border-radius: 10px;
  width: 150px;
}
.bg-red {
  background-color: red;
  border-color: rgb(218, 12, 12);
  border-radius: 10px;
  width: 150px;
}
.modal-content {
  border-radius: 10px !important;
}
.modal-header {
  background-color: #199df5;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 10px 15px !important;
}
.close {
  position: absolute;
  right: 5px;
  top: 5px;
  background-color: #ff1800 !important;
  opacity: 1 !important;
  border-radius: 50%;
  padding: 6px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-body-custom {
  padding: 1.5rem 3rem;
}
.submit {
  float: right;
  margin-top: 2.5rem;
  width: 7rem;
}
.options {
  margin-top: 2rem;
  display: flex;
  justify-content: flex-end;
}
.options button {
  margin-left: 0.5rem;
}
.alert-info {
  font-weight: 600;
  color: #fff;
  background-color: #3081dd;
  border-color: #3081dd;
}
/* Transitions Vuejs */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
input.form-control {
  font-size: 1rem;
}
input.btn {
  font-family: 'comfortaabold';
}

.select-container {
  position: relative;
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;
  }
  img {
    position: absolute;
    margin: auto;
    right: 20px;
    width: 20px;
    top: 0;
    bottom: 0;
    pointer-events: none;
  }
}
.center-block {
  display: block;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .student-edit {
    left: unset;
  }
}
@media (min-width: 767px) and (max-width: 1100px) {
  .student-edit {
    left: calc(10% - 20px);
  }
}
</style>
